module.exports = __webpack_public_path__ + "media/images/categories/color/office-f0a37593b0f6aafbb6f1c815a3d7395a.png";